import { useRef, useEffect, useCallback } from 'react';

const useClickOutsideRef = (callback, excludeRefs = [], isForSelect = true) => {
    const elementRef = useRef(null);
    const stableExcludeRefs = useRef(excludeRefs);
    useEffect(() => {
        stableExcludeRefs.current = excludeRefs;
    }, [excludeRefs]);
    const handler = useCallback((event) => {
        if (stableExcludeRefs.current.some(ref => ref.current?.contains(event.target))) {
            return;
        }
        if (elementRef.current && !elementRef.current.contains(event.target)) {
            callback(event);
        }
    }, [callback]);
    useEffect(() => {
        document.addEventListener(isForSelect ? 'click' : 'mousedown', handler);
        return () => {
            document.removeEventListener(isForSelect ? 'click' : 'mousedown', handler);
        };
    }, [isForSelect, handler]);
    return elementRef;
};

export { useClickOutsideRef };
